module.exports = __webpack_public_path__ + "img/gramedia_digital.4e741d7c.png";